export interface ComicCategory {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
}

export const categories: ComicCategory[] = [
  { id: 'cat-1', name: '恋爱', slug: 'romance', description: '甜蜜浪漫的爱情故事，心动瞬间永存', icon: 'ri-heart-line' },
  { id: 'cat-2', name: '奇幻', slug: 'fantasy', description: '魔法与异世界的奇幻冒险之旅', icon: 'ri-magic-line' },
  { id: 'cat-3', name: '动作', slug: 'action', description: '热血激燃的战斗场面，拳拳到肉', icon: 'ri-sword-line' },
  { id: 'cat-4', name: '悬疑', slug: 'mystery', description: '扑朔迷离的推理，层层反转', icon: 'ri-search-eye-line' },
  { id: 'cat-5', name: '搞笑', slug: 'comedy', description: '轻松愉快的日常，笑料不断', icon: 'ri-emotion-laugh-line' },
  { id: 'cat-6', name: '恐怖', slug: 'horror', description: '惊悚诡秘的氛围，毛骨悚然', icon: 'ri-ghost-line' },
  { id: 'cat-7', name: '剧情', slug: 'drama', description: '深刻感人的故事，触动心弦', icon: 'ri-book-open-line' },
  { id: 'cat-8', name: '日常', slug: 'slice-of-life', description: '温馨治愈的平凡生活片段', icon: 'ri-sun-line' },
  { id: 'cat-9', name: '穿越', slug: 'isekai', description: '穿越异世界，开启新人生', icon: 'ri-rocket-line' },
  { id: 'cat-10', name: '校园', slug: 'school', description: '青春洋溢的校园生活故事', icon: 'ri-building-line' },
];

export interface ComicChapter {
  id: string;
  comicId: string;
  title: string;
  chapterNumber: number;
  createdAt: string;
  pageCount: number;
}

export interface ComicItem {
  id: string;
  title: string;
  author: string;
  coverUrl: string;
  description: string;
  categoryId: string;
  categoryName: string;
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  updatedAt: string;
  tags: string[];
  chapterCount: number;
  chapters: ComicChapter[];
  isNew: boolean;
  isHot: boolean;
}